(function () {
	"use strict";

	function StackObject(world, x, y, container, sprite, size)
	{
		this.Container_constructor();
		this.mainView = null;
		this.allowUserControl = true;
		this.targetY = -1;
		this.world = world;
		this.invincibleTimer = 0;
		this.isHanging = true;
		this.size = size;
		this.beginReset = false;
		this.tween = null;
		this.garbagePos = {x:2000,y:-2000};
		this.width = cm.app.display.width * 0.5;
		this.height = cm.app.display.height * 0.5;
		this.physicsData = cm.Assets.lib.physicsObjects;
		this.init(world, x, y, container, sprite);
	}

	var p = createjs.extend(StackObject, cjs.Container);

	p.init = function (world, x, y, container, spriteObject)
	{

		var physicsData = this.physicsData[spriteObject];
		var sprite = new cjs.Sprite(cm.Assets.lib.junkSS, spriteObject).center();
		sprite.snapToPixel = false;
		sprite.framerate = 24;
		sprite.x = x;
		sprite.y = y;
		sprite.rotation = 0;
		sprite.mouseEnabled = false;
		this.displayObject = sprite;
		container.addChild(this.displayObject);

		this.body = this.buildBodyFromData(physicsData, world, b2.b2Body.b2_dynamicBody, false);
		this.body.SetPosition(new b2.b2Vec2(x / b2.b2Scale, sprite.y / b2.b2Scale));
		this.body.objectContainer = this;
		this.body.SetAngle(Math.toRad(0));
		this.body.isHanging = this.isHanging;
		this.body.size = this.size;
		this.body.isSelected = false;
		this.body.soundPlayed = false;
	};

	p.bringToCenter = function (callback)
	{
		this.targetY = this.body.GetPosition().y * b2.b2Scale;
		cjs.Tween.get(this).to({ targetY: 0 }, 2000, cjs.Ease.quadOut).call(callback);
	};

	p.buildBodyFromData = function (data, world, bodyType, bool)
	{
		var fixtures = data.fixtures;
		var body;
		var bodyDef = new b2.b2BodyDef();
		bodyDef.type = bodyType;
		bodyDef.userData = this;
		if (bool)
			bodyDef.bullet = true;

		// create the body
		body = world.world.CreateBody(bodyDef);

		// prepare fixtures
		for (var i = 0; i < fixtures.length; i++) {
			var fixture = fixtures[i];
			var fixtureDef = new b2.b2FixtureDef();
			fixtureDef.density = fixture.density;
			fixtureDef.friction = fixture.friction;
			fixtureDef.restitution = fixture.restitution;
			fixtureDef.filter.categoryBits = fixture.categoryBits;
			fixtureDef.filter.maskBits = fixture.maskBits;
			fixtureDef.filter.groupIndex = fixture.groupIndex;
			fixtureDef.isSensor = fixture.isSensor;
			if (fixture.userData) fixtureDef.userData = fixture.userData;

			if (fixture.fixtureType === "POLYGON") {
				var polygons = fixture.polygons;
				for (var p = 0; p < polygons.length; p++) {
					var vertices = [];
					for (var m = 0; m < polygons[p].length; m++) {
						vertices.push(new b2.b2Vec2(polygons[p][m][0] / b2.b2Scale, polygons[p][m][1] / b2.b2Scale));
					}
					var polygonShape = new b2.b2PolygonShape();
					polygonShape.SetAsArray(vertices, vertices.length);
					fixtureDef.shape = polygonShape;

					body.CreateFixture(fixtureDef);
				}
			} else if (fixture.fixtureType === "CIRCLE") {
				var circleShape = new b2.b2CircleShape(fixture.radius / b2.b2Scale);
				circleShape.SetLocalPosition(new b2.b2Vec2(fixture.center[0] / b2.b2Scale, fixture.center[1] / b2.b2Scale));
				fixtureDef.shape = circleShape;
				body.CreateFixture(fixtureDef);
			}
		}

		return body;
	};

	p.update = function ()
	{
		var body, pos, vel, angle, groundPos;
		if (this.allowUserControl) {
			body = this.body;
			pos = body.GetPosition();
			vel = body.GetLinearVelocity();
			angle = body.GetAngle();
			this.displayObject.x = pos.x * b2.b2Scale;
			this.displayObject.y = pos.y * b2.b2Scale;
			this.displayObject.rotation = Math.toDeg(angle);

		}


	};

	p.beginContact = function( otherBody, otherFixture, otherUserData, myBody, myFixture, contact ) {

		var fixtureAuserData = otherFixture.GetUserData();
		var fixtureBody = otherFixture.GetBody();
		if(fixtureAuserData === "stackObject"){
			if(otherFixture.m_body.isSelected && !otherFixture.m_body.soundPlayed){
				otherFixture.m_body.soundPlayed = true;
				var otherSize = otherFixture.m_body.size;
				var mySize = myFixture.m_body.size;
				if(otherSize === "small"){
					if(mySize === "small")
						app.sound.play("small-1");
					if(mySize === "medium")
						app.sound.play("small-2");
					if(mySize === "large")
						app.sound.play("small-3");
				}
				if(otherSize === "medium"){
					if(mySize === "small")
						app.sound.play("small-1");
					if(mySize === "medium")
						app.sound.play("small-2");
					if(mySize === "large")
						app.sound.play("small-3");
				}
				if(otherSize === "large"){
					if(mySize === "small")
						app.sound.play("big-1");
					if(mySize === "medium")
						app.sound.play("big-2");
					if(mySize === "large")
						app.sound.play("big-3");
				}

			}


		}

	};

	p.checkIsStackBody = function(obj)
	{
		for (var i = 0, l = this.world.bodies.length; i < l; i++) {
		   var b = this.world.bodies[i];
		   if(obj === b)
		   	return true;
		   else
		   	return false;
		}
	};

	p.kill = function ()
	{
		this.allowUserControl = false;
		var num = this.world.entities.indexOf(this);
		this.world.entities.splice(num,1);

		var bodyCheck = this.checkIsStackBody(this.body);
		if(bodyCheck){
			var bodyNum = this.world.bodies.indexOf(this.body);
			this.world.bodies.splice(bodyNum, 1);
		}

		console.log(this.world.entities, this.world.bodies);

		this.allowUserControl = false;
		cm.ViewControl.current.removeChild(this.displayObject);
		cm.ViewControl.current.projectile = null;
		this.displayObject = null;
		cjs.Tween.removeTweens(this);


		this.world.world.DestroyBody(this.body);


	};

	cm.StackObject = cjs.promote(StackObject, "Container");
})();